import { render, staticRenderFns } from "./RevokeAuthorization.vue?vue&type=template&id=70e4d6c0&scoped=true"
import script from "./RevokeAuthorization.vue?vue&type=script&lang=ts"
export * from "./RevokeAuthorization.vue?vue&type=script&lang=ts"
import style0 from "./RevokeAuthorization.vue?vue&type=style&index=0&id=70e4d6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e4d6c0",
  null
  
)

export default component.exports